module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<group-select class='form-control' id='report_document_report_document_group_id' name='report_document[report_document_group_id]' v-model='selected' v-bind:collection='collection' input_data=undefined rep_doc_document_group='document_group_filter'></group-select>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);
